export default __webpack_public_path__ + "static/jumbo-a35b0310bf4a3f420fc0eb15f3cc5a4e.png";